import { toast } from 'react-toastify';

const showToast = (type, message) => {
  // Check if dark theme is active
  const isDarkTheme = document.documentElement.classList.contains('theme-dark');
  
  const baseStyle = isDarkTheme 
    ? {
        fontSize: '14px',
        backgroundColor: 'var(--color-background-02)',
        backdropFilter: 'blur(5px)',
        color: '#ffffff',
        border: '1px solid var(--color-stroke-01)'
      }
    : {
        fontSize: '14px',
        backgroundColor: 'white'
      };

  switch (type) {
    case 'success':
      toast.success(message, {
        style: baseStyle
      });
      break;
    case 'error':
      toast.error(message, {
        style: baseStyle
      });
      break;
    case 'info':
      toast.info(message, {
        style: baseStyle
      });
      break;
    case 'warning':
      toast.warning(message, {
        style: baseStyle
      });
      break;
    case 'caution':
      toast.warning(message, {
        style: baseStyle,
        // autoClose: 30000
      });
      break;
    default:
      toast(message, {
        style: baseStyle
      });
      break;
  }
};

export default showToast;